/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetBulkAppointmentBookingsRequest
 */
export interface GetBulkAppointmentBookingsRequest {
    /**
     * 
     * @type {Array<ApiUserTasksGetLastSelectedIdParameter>}
     * @memberof GetBulkAppointmentBookingsRequest
     */
    appointmentIds: Array<ApiUserTasksGetLastSelectedIdParameter> | null;
}

/**
 * Check if a given object implements the GetBulkAppointmentBookingsRequest interface.
 */
export function instanceOfGetBulkAppointmentBookingsRequest(value: object): value is GetBulkAppointmentBookingsRequest {
    if (!('appointmentIds' in value) || value['appointmentIds'] === undefined) return false;
    return true;
}

export function GetBulkAppointmentBookingsRequestFromJSON(json: any): GetBulkAppointmentBookingsRequest {
    return GetBulkAppointmentBookingsRequestFromJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBulkAppointmentBookingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentIds': (json['appointmentIds'] == null ? null : (json['appointmentIds'] as Array<any>).map(ApiUserTasksGetLastSelectedIdParameterFromJSON)),
    };
}

export function GetBulkAppointmentBookingsRequestToJSON(json: any): GetBulkAppointmentBookingsRequest {
    return GetBulkAppointmentBookingsRequestToJSONTyped(json, false);
}

export function GetBulkAppointmentBookingsRequestToJSONTyped(value?: GetBulkAppointmentBookingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentIds': (value['appointmentIds'] == null ? null : (value['appointmentIds'] as Array<any>).map(ApiUserTasksGetLastSelectedIdParameterToJSON)),
    };
}

